/*
    !  ----------- Not In Use ---------- !
*/

import { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { viewProfile } from "apiHandler/actions/profile";
import placeholder from "assets/placeholder.png";
import MedicalJournal from "components/patient/MedicalJournal";
import MedicalRecords from "components/patient/MedicalRecords";
import PastVisits from "components/patient/PastVisits";
import ProfileHeader from "components/patient/ProfileHeader";
import ChatModal from "components/modals/chatModal";

const initalPatData = {
  fname: "",
  lname: "",
  phone: "",
  gender: "",
  age: "",
  height: "",
  weight: "",
  bloodGroup: "",
  email: "",
  address: "",
  dob: "",
  maritalStatus: "",
};

const screens = ["Medical Journal", "Medical Records", "Past Visits"];

const PatientProfile = (props) => {
  const [userImage, setUserImage] = useState(placeholder);
  const [patientData, setPatientData] = useState(null);
  const [currentScreen, setCurrentScreen] = useState("Medical Journal");
  const [showChatModal, setShowChatModal] = useState(false);
  // States for tabs
  const [medicalRecords, setMedicalRecords] = useState(null);
  const [pastVisitRecords, setPastVisitRecords] = useState(null);
  // States for Medical Journal
  const [medication, setMedication] = useState(null);
  const [allergies, setAllergies] = useState(null);
  const [vaccination, setVaccination] = useState(null);
  const [hospitalization, setHospitalization] = useState(null);
  const [surgery, setSurgery] = useState(null);
  const [familyHistory, setFamilyHistory] = useState(null);
  const [birthHistory, setBirthHistory] = useState(null);
  const location = useLocation();

  useEffect(() => {
    if (location.state.uuid) fetchMemberData();
    // eslint-disable-next-line
  }, []);

  const showScreen = () => {
    switch (currentScreen) {
      case "Medical Records":
        return (
          <MedicalRecords
            uuid={location.state.uuid}
            medicalRecords={medicalRecords}
            setMedicalRecords={setMedicalRecords}
          />
        );
      case "Past Visits":
        return (
          <PastVisits
            uuid={location.state.uuid}
            pastVisitRecords={pastVisitRecords}
            setPastVisitRecords={setPastVisitRecords}
          />
        );
      default:
        return (
          <MedicalJournal
            uuid={location.state.uuid}
            medication={medication}
            setMedication={setMedication}
            allergies={allergies}
            setAllergies={setAllergies}
            vaccination={vaccination}
            setVaccination={setVaccination}
            hospitalization={hospitalization}
            setHospitalization={setHospitalization}
            surgery={surgery}
            setSurgery={setSurgery}
            familyHistory={familyHistory}
            setFamilyHistory={setFamilyHistory}
            birthHistory={birthHistory}
            setBirthHistory={setBirthHistory}
          />
        );
    }
  };

  const fetchMemberData = async () => {
    const result = await viewProfile({ uuid: location.state.uuid });
    if (result !== "ERROR") {
      if (result.consumer_image) setUserImage(result.consumer_image);
      const dob = result.patient?.birthDate;
      setPatientData({
        fname: result.patient.name[0].given[0],
        lname: result.patient.name[0].family,
        phone: result.patient.telecom.filter((t) => t.system === "phone")[0]
          ?.value,
        gender: result.patient.gender,
        age:
          dob &&
          Math.abs(
            new Date(dob).getUTCFullYear() - new Date().getUTCFullYear()
          ),
        height: result.patient.patientExtension.general.height,
        weight: result.patient.patientExtension.general.weight,
        bloodGroup: result.patient.patientExtension.general.bloodGroup,
        email: result.patient.telecom.filter((t) => t.system === "email")[0]
          ?.value,
        address: `${result.patient.address[0]?.line.join(" ")}, ${
          result.patient.address[0]?.city
        }, ${result.patient.address[0]?.state}, ${
          result.patient.address[0]?.country
        }, Zip - ${result.patient.address[0]?.postalCode}`,
        dob,
        maritalStatus: result.patient.maritalStatus.text,
      });
    } else {
      setPatientData({ ...initalPatData });
    }
  };

  const imgErrorHandler = () => {
    setUserImage(placeholder);
  };

  if (!location.state.uuid) return <Navigate to="/dashboard" replace />;
  return (
    <div className="provider-patient-profile">
      <ProfileHeader
        patientData={patientData}
        userImage={userImage}
        showChatModal={() => setShowChatModal(true)}
        imgErrorHandler={() => imgErrorHandler()}
      />
      <nav className="nav">
        <ul>
          {screens.map((s) => (
            <li
              onClick={() => setCurrentScreen(s)}
              className={s === currentScreen ? "selected-li" : null}
              key={s}
            >
              {s}
            </li>
          ))}
        </ul>
      </nav>
      <div>{showScreen()}</div>
      {showChatModal && (
        <ChatModal
          consumerFirstName={"Edit"}
          consumerLastName={"This"}
          uuid={"test"}
          onClose={() => {
            setShowChatModal(false);
          }}
        />
      )}
    </div>
  );
};

export default PatientProfile;
